import {
  buildPrintDemandeWithTemplate,
  useDemandePrint,
  type PrintAction,
  type DemandeStore,
} from '@/features/interface/demande/shared'

export function useDemandeCPROPrintActions(store: DemandeStore<'MODEL_CPRO'>) {

  const actionPrintCerfa: PrintAction = {
    mustSave: true,
    label: 'Générer le CERFA',
    jobs: buildPrintDemandeWithTemplate<'MODEL_CPRO'>({
      store,
      typeDocumentTemplate: 'Cerfa',
      filenameKeys: ['dispositif', 'id'],
    }),
  }

  return useDemandePrint<'MODEL_CPRO'>({
    store,
    getActions: () => [actionPrintCerfa],
  })
}
